
import { PortableText } from '@portabletext/react';
import { Helmet } from "react-helmet";
import AnimateIn from '../general/AnimateIn';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';
import HeroSection from './HeroSection';




export default function Insights() {
  const images = useImages();

  if (!Array.isArray(images) || !images.length) {
    return <div></div>;
  }

  // Helper function to find an image by title
  const getImageByTitle = (title) => {
    return images.find((image) => image.title === title);
  };

  // Fetch specific images by their titles

  const maincontent = getImageByTitle('About Section One');
  const aboutcontent = getImageByTitle('About Section Two');
  const whatwecontent = getImageByTitle('About Section Three');
  const secIcon = getImageByTitle('sec-icon');

  return (
    <>

      <Helmet>
        <title>Insights | Panacea - Empowering Workflows with Smart Digital Tools </title>
        <meta name="description" content="Discover the mission behind Panacea — an all-in-one digital toolkit designed to simplify text, code, and image tasks. Learn how we help users boost productivity with powerful, user-friendly tools." />
      </Helmet>

      <HeroSection title="Insights" subtitle="Every tool you could want to edit your text.  Your online text editor is here and forever free!" />

      <section className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 order-2 order-md-1 d-flex align-items-center">
              <AnimateIn type="left" >
                <div className="textGizmo-content">
                  <div className="sec-title ">
                    <div className="px-2  d-flex align-items-center" >
                      <div>  {maincontent.Sectitle} </div>
                      <div className="px-2 sec-icon">
                        {secIcon && (

                          <img
                            src={urlFor(secIcon.file.asset)}
                            alt={secIcon.altText || 'Sanity Image'}
                          />

                        )}
                      </div>
                    </div>
                  </div>
                  <div className="home-title pt-3">
                    <span className="text-gradient" >
                      {maincontent.sectionTitle}
                    </span>
                  </div>
                  <div className="section-content">
                    <p>

                      <div className="section-content">
                        {/* Render Portable Text content */}
                        {maincontent.content && (
                          <PortableText
                            value={maincontent.content}
                            components={{
                              block: {
                                normal: ({ children }) => <p>{children}</p>,
                                h1: ({ children }) => <h1>{children}</h1>,
                                h2: ({ children }) => <h2>{children}</h2>,
                              },
                              marks: {
                                link: ({ children, value }) => (
                                  <a
                                    href={value.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                  >
                                    {children}
                                  </a>
                                ),
                              },
                            }}
                          />
                        )}
                      </div>           </p>
                    {/* 
                    <Link to="/text-gizmo" class="panacea-arrow-link">
                      {maincontent.btnlabel}  <i className='bx bxs-right-top-arrow-circle'></i>
                    </Link> */}
                  </div>
                </div>
              </AnimateIn>
            </div>
            <div className="col-md-6 col-lg-6 order-1 order-md-2 d-flex align-items-center justify-content-center">
              <AnimateIn type="right" >
                <div className="side-image">
                  {maincontent && (

                    <img
                      src={urlFor(maincontent.file.asset)}
                      alt={maincontent.altText || 'Sanity Image'}
                    />

                  )}
                </div>
              </AnimateIn>
            </div>


          </div>
        </div>

      </section>

      <section className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-6 order-1 order-md-1 d-flex align-items-center justify-content-center">
              <AnimateIn type="left" >
                <div className="side-image">
                  {aboutcontent && (

                    <img
                      src={urlFor(aboutcontent.file.asset)}
                      alt={aboutcontent.altText || 'Sanity Image'}
                    />

                  )}
                </div>
              </AnimateIn>
            </div>

            <div className="col-md-6 col-lg-5 order-2 order-md-2 d-flex align-items-center">
              <AnimateIn type="right" >
                <div className="textGizmo-content">
                  <div className="sec-title ">
                    <div className="px-2  d-flex align-items-center" >
                      <div>  {aboutcontent.Sectitle} </div>
                      <div className="px-2 sec-icon">
                        {secIcon && (

                          <img
                            src={urlFor(secIcon.file.asset)}
                            alt={secIcon.altText || 'Sanity Image'}
                          />

                        )}
                      </div>
                    </div>
                  </div>
                  <div className="home-title pt-3">
                    <span className="text-gradient" >
                      {aboutcontent.sectionTitle}
                    </span>
                  </div>
                  <div className="section-content">
                    <p>

                      <div className="section-content">
                        {/* Render Portable Text content */}
                        {aboutcontent.content && (
                          <PortableText
                            value={aboutcontent.content}
                            components={{
                              block: {
                                normal: ({ children }) => <p>{children}</p>,
                                h1: ({ children }) => <h1>{children}</h1>,
                                h2: ({ children }) => <h2>{children}</h2>,
                              },
                              marks: {
                                link: ({ children, value }) => (
                                  <a
                                    href={value.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                  >
                                    {children}
                                  </a>
                                ),
                              },
                            }}
                          />
                        )}
                      </div>           </p>
                    {/* 
                    <Link to="/text-gizmo" class="panacea-arrow-link">
                      {aboutcontent.btnlabel}  <i className='bx bxs-right-top-arrow-circle'></i>
                    </Link> */}
                  </div>
                </div>
              </AnimateIn>
            </div>


          </div>
        </div>

      </section>


      <section className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 order-2 order-md-1 d-flex align-items-center">
              <AnimateIn type="left" >
                <div className="textGizmo-content">
                  <div className="sec-title ">
                    <div className="px-2  d-flex align-items-center" >
                      <div>  {whatwecontent.Sectitle} </div>
                      <div className="px-2 sec-icon">
                        {secIcon && (

                          <img
                            src={urlFor(secIcon.file.asset)}
                            alt={secIcon.altText || 'Sanity Image'}
                          />

                        )}
                      </div>
                    </div>
                  </div>
                  <div className="home-title pt-3">
                    <span className="text-gradient" >
                      {whatwecontent.sectionTitle}
                    </span>
                  </div>
                  <div className="section-content">
                    <p>

                      <div className="section-content">
                        {/* Render Portable Text content */}
                        {whatwecontent.content && (
                          <PortableText
                            value={whatwecontent.content}
                            components={{
                              block: {
                                normal: ({ children }) => <p>{children}</p>,
                                h1: ({ children }) => <h1>{children}</h1>,
                                h2: ({ children }) => <h2>{children}</h2>,
                              },
                              marks: {
                                link: ({ children, value }) => (
                                  <a
                                    href={value.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                  >
                                    {children}
                                  </a>
                                ),
                              },
                            }}
                          />
                        )}
                      </div>           </p>
                    {/* 
                    <Link to="/text-gizmo" class="panacea-arrow-link">
                      {whatwecontent.btnlabel}  <i className='bx bxs-right-top-arrow-circle'></i>
                    </Link> */}
                  </div>
                </div>
              </AnimateIn>
            </div>
            <div className="col-md-6 col-lg-6 order-1 order-md-2 d-flex align-items-center justify-content-center">
              <AnimateIn type="right" >
                <div className="side-image">
                  {whatwecontent && (

                    <img
                      src={urlFor(whatwecontent.file.asset)}
                      alt={whatwecontent.altText || 'Sanity Image'}
                    />

                  )}
                </div>
              </AnimateIn>
            </div>


          </div>
        </div>

      </section>
    </>
  )
}
